import { YesNo } from '../../../../../types/api';
import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';
import * as Yup from 'yup';
import newLoanFormModel from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/form_models/loanFormModel';
import MortgageLoanBalanceValidation from './material_loan_obligation/MortgageLoanBalanceValidation';
import MortgageLoanTypeValidation from './material_loan_obligation/MortgageLoanTypeValidation';
import MortgageLoanLenderValidation from './material_loan_obligation/MortgageLoanLenderValidation';
import MortgageLoanYearOfMaturityValidation from './material_loan_obligation/MortgageLoanYearOfMaturityValidation';
import MortgageLoanMonthlyPaymentValidation from './material_loan_obligation/MortgageLoanMonthlyPaymentValidation';

const {
  formField: { systemPropertyCurrentlyPayingMortgage },
} = loanFormModel;

const {
  formField: { uploadOrListDebtObligations, borrowerAttestsNoDebt },
} = newLoanFormModel;

export class OutstandingLoanValidation implements ValidationSchema {
  public name = 'outstanding_loans';
  public label = '';
  public dependsOn: string[] = [
    systemPropertyCurrentlyPayingMortgage.name,
    borrowerAttestsNoDebt.name,
    uploadOrListDebtObligations.name,
  ];
  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = false;

  public when(
    payingMortgage: YesNo,
    borrowerAttestsNoDebt: YesNo,
    uploadOrListDebtObligations: string,
    schema: Yup.ArraySchema<Yup.ObjectSchema<any>>,
    context
  ) {
    if (payingMortgage === 'Yes') {
      return schema
        .of(
          Yup.lazy((loan: any) => {
            const mortgageItemSchema = Yup.object().shape({
              [MortgageLoanLenderValidation.name]:
                MortgageLoanLenderValidation.buildSchema(),
              [MortgageLoanTypeValidation.name]:
                MortgageLoanTypeValidation.buildSchema(),
              [MortgageLoanBalanceValidation.name]:
                MortgageLoanBalanceValidation.buildSchema(),
              [MortgageLoanYearOfMaturityValidation.name]:
                MortgageLoanYearOfMaturityValidation.buildSchema(),
              [MortgageLoanMonthlyPaymentValidation.name]:
                MortgageLoanMonthlyPaymentValidation.buildSchema(),
            });

            return loan?.on_system_property === 'Yes'
              ? mortgageItemSchema
              : Yup.object().strip();
          }) as unknown as Yup.AnySchema
        )
        .test(
          'at-least-one-on-system-property',
          'Please add at least one loan.',
          (loans: any[] = []) =>
            loans.some((l) => l?.on_system_property === 'Yes')
        );
    }
    return schema;
  }
}
export default new Validation(new OutstandingLoanValidation());
